module.exports = __webpack_public_path__ + "media/images/photos/28-17f7948de8c211a875afc6591dcb70a0.jpg";